var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLineWithRedIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 1340,
    viewBox: "0 0 38 1340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.015 0L19.015 1340",
    stroke: "black",
    strokeWidth: 0.992,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.015 689.03C29.5167 689.03 38.03 680.517 38.03 670.015C38.03 659.513 29.5167 651 19.015 651C8.5133 651 0 659.513 0 670.015C0 680.517 8.5133 689.03 19.015 689.03Z",
    fill: "#DB3523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.166 670.015H24.864",
    stroke: "white",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4072 674.256L7.06421 670.016L14.4072 665.775V674.256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.623 674.256L30.9661 670.016L23.623 665.775V674.256Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 1340,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLineWithRedIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/line_with_red_icon.aac24f2582071c85cbc67518d919388f.svg";